/**
 * autoName — AK-335 автогенерация имени нового поля («Поле N»).
 *
 * Чистая функция: по списку уже существующих имён полей вычисляет следующий
 * свободный номер в паттерне «Поле N». Игнорирует имена, не подходящие под
 * паттерн (например «Южный клин»), считает максимум среди «Поле N» и берёт +1.
 * Так онбординг полей подряд даёт «Поле 12», «Поле 13», … без коллизий.
 */

/** Регэксп имени вида «Поле 12» (с любым пробелом, регистронезависимо). */
const FIELD_NAME_RE = /^\s*поле\s+(\d+)\s*$/i;

/**
 * Следующее свободное имя «Поле N».
 *
 * @param existingNames — имена полей, которые уже есть у пользователя
 * @returns строка вида «Поле N», где N = max(существующих «Поле N») + 1,
 *          либо «Поле 1», если таких имён нет.
 */
export function nextFieldName(existingNames: readonly string[]): string {
  let maxN = 0;
  for (const name of existingNames) {
    const m = FIELD_NAME_RE.exec(name);
    if (m) {
      const n = Number.parseInt(m[1], 10);
      if (Number.isFinite(n) && n > maxN) maxN = n;
    }
  }
  return `Поле ${maxN + 1}`;
}
